import {httpPost,filePost} from "./http/http";

const actions = {
    pubMethod({commit},params) {
        let url = params.url;
        let param = params.param;
        return httpPost(url, param)
    },
    fileMethod({commit},params) {
        let url = params.url;
        let param = params.param;
        return filePost(url, param)
    },
}
export default {
    ...actions,
}